import React from 'react';
import { MapPin, Clock, ArrowUpRight } from 'lucide-react';
import Header from '../../components/landing/Header';
import Footer from '../../components/landing/Footer';

const upcoming = [
  {
    day: '24',
    month: 'May',
    title: 'Swim social — small breeds',
    venue: 'PetCart Nest, Sarjapur',
    time: '4:00 – 6:00 PM',
    tag: 'Swim meet',
  },
  {
    day: '07',
    month: 'Jun',
    title: 'Adoption drive · in partnership',
    venue: 'Wag & Wine',
    time: '11:00 AM – 3:00 PM',
    tag: 'Community',
  },
  {
    day: '21',
    month: 'Jun',
    title: 'Trainer Q&A · house manners',
    venue: 'Wag & Wine',
    time: '6:30 – 8:00 PM',
    tag: 'Meetup',
  },
];

const past = [
  { label: 'Pet birthdays hosted', value: '75+' },
  { label: 'Swim sessions delivered', value: '1,200+' },
  { label: 'Pet days at Nest', value: '14,000+' },
];

const CommunityEvents = () => (
  <div className="min-h-screen bg-white overflow-x-hidden">
    <Header />

    <section className="bg-white pt-40 pb-10 sm:pt-48 sm:pb-12">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">Community</p>
        <h1 className="mt-3 text-4xl font-semibold leading-tight tracking-tight text-neutral-900 sm:text-5xl">
          Meetups, swim socials, birthdays.
        </h1>
        <p className="mt-4 max-w-2xl text-base text-neutral-600 sm:text-lg">
          We host a lot through the year — most of it is announced first on Instagram. Here's
          what's coming up.
        </p>
      </div>
    </section>

    <section className="bg-white pb-16 sm:pb-20">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <ul className="divide-y divide-neutral-200 border-y border-neutral-200">
          {upcoming.map((e) => (
            <li
              key={e.title}
              className="group grid grid-cols-[auto_1fr_auto] items-center gap-5 py-6 sm:gap-8 sm:py-7"
            >
              <div className="flex h-16 w-16 flex-col items-center justify-center rounded-xl bg-primary/10 text-primary sm:h-20 sm:w-20">
                <span className="text-2xl font-semibold leading-none sm:text-3xl">{e.day}</span>
                <span className="mt-1 text-[11px] font-semibold uppercase tracking-wider">
                  {e.month}
                </span>
              </div>
              <div className="min-w-0">
                <p className="text-[11px] font-semibold uppercase tracking-wider text-neutral-500">
                  {e.tag}
                </p>
                <p className="mt-1 truncate text-lg font-semibold text-neutral-900 sm:text-xl">
                  {e.title}
                </p>
                <div className="mt-1.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-neutral-600">
                  <span className="inline-flex items-center gap-1">
                    <MapPin size={12} /> {e.venue}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <Clock size={12} /> {e.time}
                  </span>
                </div>
              </div>
              <a
                href="mailto:shekhar@petcart.com"
                className="hidden h-9 items-center gap-1 rounded-md border border-neutral-300 px-3 text-sm font-semibold text-neutral-900 hover:border-neutral-900 sm:inline-flex"
              >
                RSVP <ArrowUpRight size={14} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>

    <section className="bg-neutral-900 py-16 text-white sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">In the rear-view</p>
        <h2 className="mt-2 text-2xl font-semibold sm:text-3xl">A look at 2025</h2>
        <div className="mt-8 grid grid-cols-1 gap-px overflow-hidden rounded-2xl bg-white/10 sm:grid-cols-3">
          {past.map((p) => (
            <div key={p.label} className="bg-neutral-900 p-6">
              <p className="text-3xl font-semibold tracking-tight sm:text-4xl">{p.value}</p>
              <p className="mt-2 text-sm uppercase tracking-wider text-white/60">{p.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-white py-14 sm:py-20">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-8">
        <p className="text-xl font-medium text-neutral-900 sm:text-2xl">
          Want to host something — a meetup, an adoption drive, a birthday?
        </p>
        <a
          href="mailto:shekhar@petcart.com"
          className="mt-5 inline-flex items-center justify-center gap-2 rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary/90"
        >
          shekhar@petcart.com <ArrowUpRight size={14} />
        </a>
      </div>
    </section>

    <Footer />
  </div>
);

export default CommunityEvents;
